import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message/MessageSlice';
import ExceptionService from '../../../service/exceptionLogs/ExceptionLogs';

export const getException = createAsyncThunk(
  'Exception/getException',
  async (queryParams, thunkAPI) => {
    debugger;
    try {
      const response = await ExceptionService.getException(queryParams);
      return { ExceptionData: response.data };
    } catch (error) {
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  },
);

const ExceptionLogsSlice = createSlice({
  name: 'ExceptionLogs',
  initialState: {
    Exception: null,
    ExceptionData: [],
    loading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getException.pending, (state) => {
        state.loading = true;
      })
      .addCase(getException.fulfilled, (state, action) => {
        debugger;
        state.loading = false;
        state.ExceptionData = action.payload.ExceptionData;
        state.error = null;
      })
      .addCase(getException.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default ExceptionLogsSlice.reducer;
